import { render, staticRenderFns } from "./Cigarette.vue?vue&type=template&id=8401552a&scoped=true"
import script from "./Cigarette.vue?vue&type=script&lang=js"
export * from "./Cigarette.vue?vue&type=script&lang=js"
import style0 from "./Cigarette.vue?vue&type=style&index=0&id=8401552a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8401552a",
  null
  
)

export default component.exports